import KendoScrollView from '../KendoScrollView'

let KendoScrollViewInstaller = class {
    static install(Vue) {
        Vue.component(KendoScrollView.name, KendoScrollView)
    }
}

export default KendoScrollViewInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoScrollViewInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-scrollview-vue-wrapper/src/kendo-scrollview-installer/index.js